<template>
  <div class="dealer-terms">
    <!-- Header Section -->
    <section class="terms-hero">
      <v-container>
        <div class="hero-content">
          <div class="hero-icon">
            <i class="material-icons-round">description</i>
          </div>
          <h1 class="hero-title">📜 AutoSyncX™ Terms of Service</h1>
          <p class="effective-date">Effective Date: [Insert Date]</p>
          <p class="hero-subtitle">
            Welcome to AutoSyncX™. By accessing or using our platform, you agree to the following terms:
          </p>
        </div>
      </v-container>
    </section>

    <!-- Terms Content -->
    <section class="terms-content">
      <v-container>
        <div class="terms-sections">
          
          <div class="term-section" v-for="term in terms" :key="term.id">
            <h2 class="term-title">{{ term.title }}</h2>
            <p class="term-description">{{ term.description }}</p>
          </div>

        </div>
      </v-container>
    </section>

    <!-- Back to Home -->
    <section class="back-section">
      <v-container>
        <div class="back-content">
          <v-btn
            class="back-btn"
            large
            outlined
            @click="goBack"
          >
            <i class="material-icons-round">arrow_back</i>
            Back to Home
          </v-btn>
        </div>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "DealerTerms",
  data() {
    return {
      terms: [
        {
          id: 1,
          title: 'Eligibility',
          description: 'You must be at least 18 years old and legally authorized to represent your dealership or act as a referral agent.'
        },
        {
          id: 2,
          title: 'Platform Use',
          description: 'AutoSyncX™ provides tools for dealerships and referral agents to connect, share inventory, and track commissions. Misuse (fraud, scraping outside approved API, false leads, etc.) may result in account termination.'
        },
        {
          id: 3,
          title: 'Commissions',
          description: 'Commission structures are set by AutoSyncX™ and/or participating dealerships. Payments are automated and transparent within the dashboard.'
        },
        {
          id: 4,
          title: 'Data Accuracy',
          description: 'Users must provide accurate dealership, inventory, and contact information. AutoSyncX™ is not liable for incorrect or misleading data input by users.'
        },
        {
          id: 5,
          title: 'Limitation of Liability',
          description: 'AutoSyncX™ is not responsible for disputes between dealers, agents, and buyers. Our platform facilitates transactions but does not guarantee sales outcomes.'
        },
        {
          id: 6,
          title: 'Termination',
          description: 'AutoSyncX™ reserves the right to suspend or terminate accounts for violation of terms, fraudulent activity, or non-payment of platform fees.'
        }
      ]
    }
  },
  methods: {
    goBack() {
      // Navigate back to home page
      this.$router.push('/dealers');
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  },
  mounted() {
    // Scroll to top when component is mounted
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
</script>

<style scoped>
/* Terms Page Styles */
.dealer-terms {
  font-family: 'Inter', sans-serif;
  min-height: 100vh;
}

/* Hero Section */
.terms-hero {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 80px 0 60px;
  text-align: center;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.hero-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.hero-icon i {
  font-size: 2.5rem;
  color: white;
}

.hero-title {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 16px;
  line-height: 1.2;
}

.effective-date {
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 24px;
  font-style: italic;
}

.hero-subtitle {
  font-size: 1.2rem;
  color: #4a5568;
  line-height: 1.6;
}

/* Terms Content */
.terms-content {
  padding: 80px 0;
  background: #ffffff;
}

.terms-sections {
  max-width: 800px;
  margin: 0 auto;
}

.term-section {
  margin-bottom: 40px;
  padding: 30px;
  background: #f8fafc;
  border-radius: 12px;
  border-left: 4px solid #007bff;
}

.term-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 16px;
}

.term-description {
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.7;
  margin: 0;
}

/* Back Section */
.back-section {
  padding: 60px 0;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  text-align: center;
}

.back-btn {
  background: white !important;
  color: #007bff !important;
  border: 2px solid #007bff !important;
  padding: 16px 32px !important;
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  border-radius: 50px !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
}

.back-btn:hover {
  background: #007bff !important;
  color: white !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 123, 255, 0.3) !important;
}

.back-btn i {
  margin-right: 8px;
  font-size: 1.2rem;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2.2rem;
  }
  
  .hero-subtitle {
    font-size: 1.1rem;
  }
  
  .terms-content {
    padding: 60px 0;
  }
  
  .term-section {
    padding: 24px 20px;
    margin-bottom: 30px;
  }
  
  .term-title {
    font-size: 1.3rem;
  }
  
  .term-description {
    font-size: 1rem;
  }
  
  .terms-hero {
    padding: 60px 0 40px;
  }
  
  .back-section {
    padding: 40px 0;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 1.8rem;
  }
  
  .hero-icon {
    width: 60px;
    height: 60px;
  }
  
  .hero-icon i {
    font-size: 2rem;
  }
  
  .term-section {
    padding: 20px 16px;
  }
  
  .back-btn {
    padding: 14px 28px !important;
    font-size: 1rem !important;
  }
}
</style>
